import { styled } from "@vw-marketing/us-components";

export const StyledManageContactsEmailFormWrapper: any = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  margin-top: ${({ theme }) => theme.size.static400};
`;

export const StyledManageContactsEmailButtonContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static350};
  width: 100%;
`;
